module.exports = "<div class=\"row gallery-image\">\n  <!-- REPLACE THIS WITH JUMBOTRON / IMAGE SLIDER -->\n  <img src=\"/assets/img/home/home-cat1.jpg\" alt=\"\" class=\"img-fluid rounded mx-auto d-block\">\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home-gallery/home-gallery.component.html
// module id = ./src/app/components/home/home-gallery/home-gallery.component.html
// module chunks = main